import { createApp } from 'vue'
import App from './App.vue'
import 'bootstrap/dist/css/bootstrap.min.css'
import router from './router'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'

const app = createApp(App)
app.config.globalProperties.$apiUrl = process.env.VUE_APP_URL + '/api/'
app.use(router).mount('#app')
app.component('v-select', vSelect)

